import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './authentication/guard/auth.guard';
import { SigninComponent } from './authentication/components/signin/signin.component';

const routes: Routes = [
  { path: 'signin', component: SigninComponent},
  { path: '', loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule), canActivateChild: [AuthGuard]},

  {path: '**', redirectTo: '', pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
